// extracted by mini-css-extract-plugin
var _1 = "BEGZT";
export { _1 as "peopleList" }
